export interface ChecklistCompleteResponse {
  success: boolean;
  completedSteps: string[];
}

export const completeChecklistStep = async (stepId: string): Promise<ChecklistCompleteResponse> => {
  const result = await fetch(`/_api/user/onboarding/checklist/complete`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ stepId }),
  });

  if (!result.ok) {
    throw new Error("Failed to complete checklist step");
  }

  return result.json();
};
